<template lang="pug">
.v-field-select.field-select(:class="{'field-select--open': open, 'field-select--sm': field.size === 'sm'}")
	label.field-select__label(v-if="field.label" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	button.field-select__btn(type="button" @click="openList" :id="uniqueId" :disabled="field.disabled")
		span.field-select__btn-text(v-if="localValue && localValue.length" key="text") {{computedText}}
		span.field-select__btn-placeholder(v-else="" key="placeholder") {{field.placeholder}}
		v-svg-icon.field-select__btn-arrow(:icon="'chevron-down-sm'")
	.field-select__list.scrollbar(:class="field?.className")
		.field-select__list-container
			.tabs-select(v-if="field.tabs" )
				.tabs-select__item(v-for="(tab, tabIndex) in field.tabs" :key="tabIndex")
					button.btn.btn--sm(:class="{'btn--primary': currentTabIndex === tabIndex}"
						type="button"
						ref="tab"
						:disabled="tab.disabled"
						@click="setTabsData(tabIndex, tab.slotName)")
						| {{tab.name}}
			template(v-for="(option, index) in field.options")
				template(v-if="option.all" )
					label.field-select__list-item.field-select__list-item--flex(v-if="option.slotName === slotName" :class="option?.className")
						input.field-select__input(
							type="checkbox"
							:id="uniqueId + index"
							v-model="selectAll"
							@change="all"
							:checked="selectAll"
							:disabled="field.disabled || option.disabled")
						.field-checkbox__visual
						span.field-checkbox__text {{option.text}}
				template(v-else )
					label.field-select__list-item.field-select__list-item--flex(v-if="option.slotName === slotName" :for="uniqueId2 + index" :class="option?.className")
						input.field-select__input(
							type="checkbox"
							:id="uniqueId2 + index"
							:value="option.value"
							:checked="isSelected(option.value)"
							@change="toggleOption(option.value)"
							:disabled="field.disabled || option.disabled")
						.field-checkbox__visual
						span.field-checkbox__text {{option.text}}
			button.btn.btn--primary.field-select__mobile-apply(
				v-if="field.mobileApplyText && isSm"
				type="button"
				:disabled="!localValue.length"
				@click.stop="open = false") {{ field.mobileApplyText }}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [isMobMixin],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Array, Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: [],
			selectAll: null,
			open: false,
			currentTabIndex: 0,
			slotName: '',
			uniqueId: uniqueId('field-multi-select'),
			uniqueId2: uniqueId('field-multi-select-checkbox'),
		};
	},

	computed: {
		computedText() {
			let resultArr = [];
			for (let i = 0; i < this.localValue.length; i++) {
				for (let n = 0; n < this.field.options.length; n++) {
					if (this.field.options[n].value === this.localValue[i]) {
						resultArr.push(this.field.options[n].text);
					}
				}
			}
			return resultArr.join(', ');
		},

		activeOption() {
			if (this.field && this.field.options && this.field.options.length) {
				return this.field.options.find(option => option.value === this.localValue);
			}
			return null;
		},
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},

		localValue() {
			this.setSelectAll();
		}

	},

	created() {
		this.setSlotName();
		this.updateLocalValue();
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	// mounted() {
	// 	this.checkTabsDisabled()
	// },

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		openList() {
			this.open = !this.open
		},

		setSlotName() {
			if(this.field.tabs && Array.isArray(this.field.tabs)) {
				const currentTabIndex = this.field.tabs.findIndex(item => item.active);
				if (currentTabIndex > -1) {
					this.currentTabIndex = currentTabIndex;
					this.slotName = this.field.tabs[currentTabIndex].slotName;
				} else {
					this.slotName = this.field.tabs[0].slotName;
				}
			}
		},

		// checkTabsDisabled() {
		// 	this.isTabsDisabled = this.$refs.tab.some(tab => tab.disabled)
		// },
		//
		// setDisable(slotName) {
		// 	return this.slotName !== slotName && this.localValue.length
		// },

		updateLocalValue() {
			const values = Array.isArray(this.modelValue)
				? this.modelValue
				: (this.modelValue === null || this.modelValue === undefined || this.modelValue === '' ? [] : [this.modelValue]);

			// Pfilter expects an array, but this field allows only one selected property type.
			this.localValue = values.length ? [values[0]] : [];
			this.setSelectAll();
			// this.$nextTick(() => {
			// 	this.checkTabsDisabled()
			// });
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		isSelected(value) {
			return this.localValue.includes(value);
		},

		toggleOption(value) {
			this.localValue = this.isSelected(value) ? [] : [value];
			this.handleInput();
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		},

		setTabsData (tabIndex, slotName) {
			this.currentTabIndex = tabIndex;
			this.slotName = slotName;
			this.localValue = [];
			this.handleInput();
		},

		all() {
			const selecedtSlotsValues = this.field.options.filter(option => option.slotName === this.slotName).map(option => option.value);
			if(this.selectAll) {
				this.localValue = selecedtSlotsValues
				this.handleInput();
			} else {
				this.localValue = []
				this.handleInput();
			}
		},

		setSelectAll() {
			const filtredOptions = this.field.options.filter(option => option.slotName === this.slotName)
			const filtredValues = this.localValue.filter(value => filtredOptions.some(option => option.value === value))
			this.selectAll = filtredValues.length === filtredOptions.length - 1;
		}
	}
};
</script>
